import React from "react";
import { motion } from "framer-motion";
import "../styles/AboutSection.css";
import Profile from "./ProfileCard";
import CoreValues from "./values";
import Vision from "./MissionSection";

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const AboutSection = () => {
  return (
    <div className="about-section">
      <div className="about-content">
        <div className="text-content">
          <motion.div
            className="text-blocks"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <div className="about-about-us-section">
              <div className="about-about-us-container">
                <div className="about-about-us-images">
                  <img
                    src="/Hero.png"
                    alt="NexaGrowth"
                    className="about-img-top"
                  />
                </div>

                <div className="about-about-us-text">
                  <h2 className="about-title">Who we are?</h2>
                  <p className="italic-text">
                    <strong>
                      <em>Shaping Africa’s Future — One Business at a Time</em>
                    </strong>
                  </p>
                  <p className="about-description">
                    NexaGrowth Africa was born from a vision to bridge the gap
                    between potential and performance in African enterprise.
                    Founded in Ghana, we are a passionate team of consultants,
                    strategists, creatives, and entrepreneurs dedicated to
                    transforming organizations and building future-ready
                    businesses.
                  </p>
                </div>
              </div>
            </div>
            <div className="vm-container">
              <Vision />
            </div>

            <div className="stats">
              <div className="stat">
                <p className="label">Founded</p>
                <p className="value">2024</p>
              </div>
              <div className="stat">
                <p className="label">Countries</p>
                <p className="value">2</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="ceo-head">
        <h2>
          <span>Message</span> from Our <span className="highlight">CEO</span>
        </h2>
      </div>
      <motion.div
        className="Profile"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <Profile />
      </motion.div>
      <motion.div
        className="core-values"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <CoreValues />
      </motion.div>
    </div>
  );
};

export default AboutSection;
